import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { serviceConstants, stateOptionsSample } from 'src/app/constants/service.constants';
import * as $ from 'jquery';
import { Subject } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { UserService } from "src/app/services/user.service";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateObject, Document_Upload_File, ScreenResponseModel } from 'src/app/models/common';
import { GrantsDatashareService } from '../../../../services/grants/grants-datashare.service';
import { DatePipe } from '@angular/common';
import { FileService } from 'src/app/services/file.service';
@Component({
  selector: 'app-grants-budget-view-modal',
  templateUrl: './grants-budget-view-modal.component.html',
  styleUrls: ['./grants-budget-view-modal.component.scss']
})
export class GrantsBudgetViewModalComponent implements OnInit {
  @Input() public Content: any;
  appid: string = "";
  formFields;
  stateOptions = stateOptionsSample;
  grantcurrencycode: any = "";
  granttype: number;
  budgetForm: UntypedFormGroup;
  permission: string;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  budgetTypeOptions = [];
  budgetSubTypeOptions = [];
  ApplicationID: any;
  SCREEN_MODEL: any = null;
  ScreenName: string = "";
  StatusStr: any;
  grantsApp: any;
  isSubmitVisible: boolean = false;
  GeneralInformationFields: any;
  Application_Type_ID: string = "";
  staticformFields: any;
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  staticformFieldsLstest: any;
  Currency_ID: string = "";
  Currenct_Currency_Symbol: string = "";
  Target_Currency_Symbol: string = "";
  CONVERSION_RATE: number = 0;
  RequestedAmount_Target_Convert: number = 0;
  AllocatedAmount_Target_Convert: number = 0;
  TotalAmount_Target_Convert: number = 0;
  consumedAmount_Target_Convert: number = 0;
  orgCurrency: string;
  currency: string;
  userType: string;
  minDate: Date;

  maxDate: Date = new Date();
  disabledPresentDate = [
    new Date()
  ];
  IsAllocatedDateModified: boolean = false;
  ALLOCATE_DATE: DateObject;
  uploadedFiles: Document_Upload_File[] = [];
  expStaticFields: any;
  constructor(
    private summaryService: GrantsSummaryService,
    public modalRef: NgbActiveModal,
    private userService: UserService,
    private commonService: CommonService,
    public grantsDatashare: GrantsDatashareService,
    private fileService: FileService,
    private datepipe: DatePipe,
  ) {
  }
  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.appid)
      .subscribe(summary => {
        if (screenCode == 'SCR-026') {
          this.staticformFields = summary["Data"];
        }
        else {
          this.expStaticFields = summary["Data"];
        }
      });
  }
  ngOnInit() {
    this.grantsDatashare.GrantApplicationID.subscribe(x => {
      this.appid = x;
    });
    if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
      this.grantsDatashare.Application_Type_ID.subscribe(x => {
        this.Application_Type_ID = x;
      });
    }
    if (this.Currency_ID == null || this.Currency_ID == undefined || this.Currency_ID == "") {
      this.grantsDatashare.Currency_ID.subscribe(x => {
        this.Currency_ID = x;
      });
    }
    this.userType = this.userService.getUserType();
    this.GetParentScreenFieldsConfigControls('GC01');
    this.granttype = 1;
    this.GetScreenConfigControls('SCR-026');
    this.getStaticFiledsData('SCR-026');
    this.getStaticFiledsData('SCR-030');
    this.grantsApp = this.commonService.getGrantsApp();
    this.getOnIntMethods();
    this.disable();
    this.budgetForm.controls['REQUESTED_AMOUNT']?.valueChanges.subscribe(value => {
      if (this.userType == "E") {
        const amount = Number(value);
        const qty = Number(this.CONVERSION_RATE);
        this.RequestedAmount_Target_Convert = Number((amount / qty).toFixed(2));
      }
    });
    this.budgetForm.controls['TOTAL_FEE']?.valueChanges.subscribe(value => {
      if (this.userType == "E") {
        const amount = Number(value);
        const qty = Number(this.CONVERSION_RATE);
        this.TotalAmount_Target_Convert = Number((amount / qty).toFixed(2));
      }
    });

    this.budgetForm.controls['ALLOCATION_AMOUNT']?.valueChanges.subscribe(value => {
      if (this.userType == "I") {
        const amount = Number(value);
        const qty = Number(this.CONVERSION_RATE);
        this.AllocatedAmount_Target_Convert = Number((amount * qty).toFixed(2));
      }
    });
    this.budgetForm.controls['EXPENDITURE_AMOUNT']?.valueChanges.subscribe(value => {
      if (this.userType == "E") {
        const amount = Number(value ?? 0);
        const qty = Number(this.CONVERSION_RATE);
        this.consumedAmount_Target_Convert = Number((amount / qty).toFixed(2));
      }
    });
  }


  getOnIntMethods() {
    this.heading = this.Content.heading;

    this.budgetForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      APPLICATION_ID: new UntypedFormControl(null),
      BUGET_TYPE_ID: new UntypedFormControl("", [Validators.required]),
      BUDGET_SUB_TYPE_ID: new UntypedFormControl("", [Validators.required]),
      NOTES: new UntypedFormControl("", [Validators.required]),
      REQUESTED_AMOUNT: new UntypedFormControl("", [Validators.required]),
      TOTAL_FEE: new UntypedFormControl("", [Validators.required]),
      STATUS: new UntypedFormControl(1),
      ALLOCATION_AMOUNT: new UntypedFormControl(null),
      ALLOCATION_DATE: new UntypedFormControl(null),
      ALLOCATION_DATEO: new UntypedFormControl(null),
      ALLOCATION_NOTES: new UntypedFormControl(null),
      EXPENDITURE_AMOUNT: new UntypedFormControl(null),
      BALANCE_AMOUNT: new UntypedFormControl(null),
    });

    this.getFundCategoryList();
    if (this.heading != "Add") {
      this.GetEditData();

    }
    else {
      this.StatusStr = "Draft";
    }

    this.permission = this.commonService.getPagePermission("GC05").toLowerCase();
    if (this.permission === 'view') {
      setTimeout(() => {
        this.budgetForm.disable({ emitEvent: false });
      }, 100);
    }

  }

  SaveCME_GM_APP() {
    let uploadData = new FormData();
    uploadData.append("ScreenControlsData", JSON.stringify(this.GeneralInformationFields));
    uploadData.append("APPLICATION_TYPE_ID", this.Application_Type_ID);
    uploadData.append("SUBMIT_STATUS", "0");
    uploadData.append("Currency_ID", this.Currency_ID);
    return this.summaryService.SaveCMEGeneralInfo("api/GMAPPCME/Insert", uploadData);
  }

  GetParentScreenFieldsConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, this.ApplicationID, (ScreenData) => {
      this.GeneralInformationFields = ScreenData["SCREEN_CONTROL"];
    });
  }

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, this.ApplicationID, (ScreenData) => {
      this.SCREEN_MODEL = ScreenData;
      this.ScreenName = this.SCREEN_MODEL?.NAME;
      this.staticformFieldsLstest = ScreenData["SCREEN_CONTROL"];
    });
  }

  GetEditData(): void {
    this.summaryService.getBudget(this.Content.content.id, this.appid).subscribe(summary => {
      if (summary) {
        this.budgetForm.patchValue({
          ID: summary["ID"],
          APPLICATION_ID: summary["APPLICATION_ID"],
          BUGET_TYPE_ID: summary["BUGET_TYPE_ID"],
          BUDGET_SUB_TYPE_ID: summary["BUDGET_SUB_TYPE_ID"],
          TOTAL_FEE: summary["TOTAL_FEE"],
          REQUESTED_AMOUNT: summary["REQUESTED_AMOUNT"],
          NOTES: summary["NOTES"],
          STATUS: summary["STATUS"],
          ALLOCATION_AMOUNT: summary["ALLOCATION_AMOUNT"],
          ALLOCATION_DATE: summary["ALLOCATION_DATE"],
          ALLOCATION_NOTES: summary["ALLOCATION_NOTES"],
          EXPENDITURE_AMOUNT: summary["EXPENDITURE_AMOUNT"],
        });
        this.uploadedFiles = summary["uploadFiles"];
        this.getFundSubCategoryList(summary["BUGET_TYPE_ID"]);

        if (this.heading == "View") {
          this.budgetForm.disable();
        }
        else {
          if (this.heading != "Add" && summary["STATUS"] >= 2) {
            this.budgetForm.controls["BUGET_TYPE_ID"].disable();
            this.budgetForm.controls["BUDGET_SUB_TYPE_ID"].disable();
            this.budgetForm.controls["TOTAL_FEE"].disable();
            this.budgetForm.controls["REQUESTED_AMOUNT"].disable();
            this.budgetForm.controls["NOTES"].disable();
          }
          if (this.heading != "Add" && summary["STATUS"] >= 11) {
            this.budgetForm.controls["ALLOCATION_AMOUNT"].disable();
            this.budgetForm.controls["ALLOCATION_DATE"].disable();
            this.budgetForm.controls["ALLOCATION_NOTES"].disable();
          }
        }
        this.StatusStr = summary["StatuStr"];
        if (summary["APPROVED_DATE"] != null && summary["APPROVED_DATE"] != "") {
          let formd2 = new Date(summary["APPROVED_DATE"]);
          this.minDate = formd2;
        }
        debugger;
        if (summary["ALLOCATION_DATE"] != null && summary["ALLOCATION_DATE"] != "") {
          let formd2 = this.commonService.getdisplayedDate(this.budgetForm.controls["ALLOCATION_DATE"].value);

          this.budgetForm.controls["ALLOCATION_DATE"].setValue(formd2);
          if (formd2 < new Date) {
            this.minDate = formd2;
          }
        }
        this.StatusStr = summary["StatuStr"];
        if (this.extendedForm) {
          this.extendedForm.rowid = summary.ID;
          this.extendedForm?.getResponse();
        }
        this.CONVERSION_RATE = summary["CONVERSION_RATE"];
        if (this.userType == "E") {
          if (summary["STATUS"] >= 2) {
            this.RequestedAmount_Target_Convert = parseFloat((parseFloat(summary['REQUESTED_AMOUNT']) / summary["CONVERSION_RATE"]).toFixed(2));
            if (summary['ALLOCATION_AMOUNT']) {
              this.AllocatedAmount_Target_Convert = parseFloat((parseFloat(summary['ALLOCATION_AMOUNT']) / summary["CONVERSION_RATE"]).toFixed(2));
            }
            if (this.budgetForm.controls['TOTAL_FEE'].value) {
              this.TotalAmount_Target_Convert = parseFloat((parseFloat(this.budgetForm.controls['TOTAL_FEE'].value) / summary["CONVERSION_RATE"]).toFixed(2));
            }
            if (summary['EXPENDITURE_AMOUNT']) {
              this.consumedAmount_Target_Convert = parseFloat((parseFloat(summary['EXPENDITURE_AMOUNT']) / summary["CONVERSION_RATE"]).toFixed(2));
            }
            else {
              this.consumedAmount_Target_Convert = 0;
            }
          }
        }
        else {
          this.RequestedAmount_Target_Convert = parseFloat((parseFloat(summary['REQUESTED_AMOUNT']) * summary["CONVERSION_RATE"]).toFixed(2));
          if (summary['ALLOCATION_AMOUNT']) {
            this.AllocatedAmount_Target_Convert = parseFloat((parseFloat(summary['ALLOCATION_AMOUNT']) * summary["CONVERSION_RATE"]).toFixed(2));
          }
          if (this.budgetForm.controls['TOTAL_FEE'].value) {
            this.TotalAmount_Target_Convert = parseFloat((parseFloat(this.budgetForm.controls['TOTAL_FEE'].value) * summary["CONVERSION_RATE"]).toFixed(2));
          }
          if (summary['EXPENDITURE_AMOUNT']) {
            this.consumedAmount_Target_Convert = parseFloat((parseFloat(summary['EXPENDITURE_AMOUNT']) * summary["CONVERSION_RATE"]).toFixed(2));
          }
        }
      }
    });
  }
  getFundCategoryList() {
    let model = new ScreenResponseModel();
    if (this.appid == "" || this.appid == null || this.appid == undefined) {
      model.AppId = "-1";
    }
    else {
      model.AppId = this.appid;
      this.Currency_ID = "-1";
    }
    this.summaryService.getBudgetTypeList(model.AppId, this.Content.content.id, this.Currency_ID).subscribe((result) => {
      if (result != null) {
        this.budgetTypeOptions = [{ label: "Select", value: null, checked: true }].concat(result["MasterData1"]);
        if (result["AppCurrencyDropdown"] != null) {
          this.currency = result["AppCurrencyDropdown"].appCurrency_Symbol;
          this.orgCurrency = result["AppCurrencyDropdown"].orgCurrency_Symbol;
          if (this.userType == "E") {
            this.Currenct_Currency_Symbol = result["AppCurrencyDropdown"].appCurrency_Symbol;
            this.Target_Currency_Symbol = result["AppCurrencyDropdown"].orgCurrency_Symbol;
          }
          else {
            this.Currenct_Currency_Symbol = result["AppCurrencyDropdown"].orgCurrency_Symbol;
            this.Target_Currency_Symbol = result["AppCurrencyDropdown"].appCurrency_Symbol;
          }
        }
      }
    });
  }

  getFundSubCategoryList(typeid: any) {
    let model = new ScreenResponseModel();
    model.Id = typeid.value == undefined ? typeid : typeid.value;
    if (this.appid == "" || this.appid == null || this.appid == undefined) {
      model.AppId = "-1";
    }
    else {
      model.AppId = this.appid;
    }
    model.RowId = this.Content.content.id;
    this.summaryService.getBudgetSubTypeList(model).subscribe((result) => {
      if (result != null) {
        this.budgetSubTypeOptions = [{ label: "Select", value: null, checked: true }].concat(result);
        this.disable();
      }
    });
  }

  disable() {
    if (this.budgetForm.controls['BUGET_TYPE_ID'].value == null || this.budgetForm.controls['BUGET_TYPE_ID'].value == "" || this.budgetForm.controls['BUGET_TYPE_ID'].value == undefined) {
      this.budgetForm.controls['BUDGET_SUB_TYPE_ID'].disable();
    } else {
      if (this.heading != "View" && !(this.budgetForm.controls['STATUS'].value > 2))
        this.budgetForm.controls['BUDGET_SUB_TYPE_ID'].enable();
    }
  }

  getSelectedValue(value: any): void {
    this.getFundSubCategoryList(value);
    this.budgetForm.controls["BUDGET_SUB_TYPE_ID"].setValue(null);
  }

  SaveBudget() {
    if (this.validateControls()) {
      const formData = this.budgetForm.getRawValue();
      formData.NOTES = formData.NOTES == null ? null : formData.NOTES == undefined ? undefined : formData.NOTES.trim();
      formData["TOTAL_FEE"] = parseFloat(formData["TOTAL_FEE"]);
      formData["REQUESTED_AMOUNT"] = parseFloat(formData["REQUESTED_AMOUNT"]);
      formData["GRANTTYPE"] = this.granttype;
      formData["CURRENCY_SYMBOL"] = this.grantcurrencycode;
      formData["APPLICATION_ID"] = this.appid;
      if (formData["ALLOCATION_AMOUNT"] != null && formData["ALLOCATION_AMOUNT"] != undefined && formData["ALLOCATION_AMOUNT"] != "") {
        formData["ALLOCATION_AMOUNT"] = parseFloat(formData["ALLOCATION_AMOUNT"]);
      }
      if (formData["EXPENDITURE_AMOUNT"] != null && formData["EXPENDITURE_AMOUNT"] != undefined && formData["EXPENDITURE_AMOUNT"] != "") {
        formData["EXPENDITURE_AMOUNT"] = parseFloat(formData["EXPENDITURE_AMOUNT"]);
      }

      if (formData["STATUS"] > 3 && formData["ALLOCATION_AMOUNT"]) {
        formData["STATUS"] = 11;
      }

      if (formData["ALLOCATION_DATE"] != null && formData["ALLOCATION_DATE"] != "") {
        formData["ALLOCATION_DATE"] = new Date(formData["ALLOCATION_DATE"]);
        formData["AllocationDateO"] = this.GetAllocateDate();
      }
      if (this.uploadedFiles != null && this.uploadedFiles != undefined && this.uploadedFiles.length > 0) {
        formData["UploadFiles"] = this.uploadedFiles.map(x => {
          return {
            ID: x.ID,
            DOCUMENT_NAME: x.DOCUMENT_NAME,
            Status: x.Status,
            TRANSACTION_ID: formData.ID,
          }
        });
      }

      if (this.heading == "Add") {
        if (!this.appid) {
          this.SaveCME_GM_APP().subscribe((result) => {
            if (result != null && result.Status == 0) {
              this.ApplicationID = result["TransactionID"];
              this.appid = result["TransactionID"];
              this.commonService.appId = this.appid;
              formData["APPLICATION_ID"] = this.appid;
              this.grantsDatashare.setGrantApplicationID(this.ApplicationID);
              this.summaryService.Insert('api/gmbudget/insert', formData).subscribe(summary => {
                if (summary.Status == 0) {
                  this.extendedForm.saveControls(summary.TransactionID, this.appid, summary.TransactionCode).subscribe(result => {
                    if (result.Status === 0) {
                      this.commonService.SuccessBanner(this.ScreenName + " saved successfully");
                      this.commonService.refreshApplicationPage(this.appid, "grants");
                      this.modalRef.close();
                    }
                    else {
                      this.commonService.ValidationBanner(result.Message);
                    }
                  });
                }
              });

            }
          })
        }
        else {
          formData["APPLICATION_ID"] = this.appid;
          this.summaryService.Insert('api/gmbudget/insert', formData).subscribe(summary => {
            if (summary.Status == 0) {
              this.extendedForm.saveControls(summary.TransactionID, this.appid, summary.TransactionCode).subscribe(result => {
                if (result.Status === 0) {
                  this.commonService.SuccessBanner(this.ScreenName + " saved successfully");
                  this.modalRef.close();
                }
                else {
                  this.commonService.ValidationBanner(result.Message);
                }
              });
            }
          });
        }
      }
      else {
        formData["APPLICATION_ID"] = this.appid;
        this.summaryService.Update('api/gmbudget/update', formData).subscribe(result => {
          if (result.Status === 0 || result.ErrorCode == "NOCHANGES") {
            this.extendedForm.saveControls(result.TransactionID, this.appid, result.TransactionCode).subscribe(summary1 => {
              if (summary1.ErrorCode === "NOCONTROLS") {
                if (result.Status === 0) {
                  this.commonService.SuccessBanner(this.ScreenName + " updated successfully");
                  this.modalRef.close();
                }
                else {
                  this.commonService.ValidationBanner(result.Message);
                }
              } else {
                if (result.ErrorCode === "NOCHANGES" && summary1.ErrorCode === "NOCHANGES") {
                  this.commonService.ValidationBanner(result.Message);
                }
                else {
                  this.commonService.SuccessBanner(this.ScreenName + " updated successfully");
                  this.modalRef.close();
                }
              }
            });
          }
          else {
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }
    }
  }

  validateControls() {
    let formDate = this.budgetForm.getRawValue();
    let isValid = true;
    let message = "";
    if (this.staticformFields?.BUGET_TYPE_ID.RECORD_STATE == 1 && this.staticformFields?.BUGET_TYPE_ID.IS_MANDATORY) {
      if (formDate.BUGET_TYPE_ID === null || formDate.BUGET_TYPE_ID === "" || formDate.BUGET_TYPE_ID === undefined) {
        $("#BUGET_TYPE_ID").addClass("ng-touched ng-invalid validate-error");
        $("#BUGET_TYPE_ID").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.BUGET_TYPE_ID.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#BUGET_TYPE_ID").addClass("ng-untouched ng-valid");
        $("#BUGET_TYPE_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.BUDGET_SUB_TYPE_ID.RECORD_STATE == 1 && this.staticformFields?.BUDGET_SUB_TYPE_ID.IS_MANDATORY) {
      if (formDate.BUDGET_SUB_TYPE_ID === null || formDate.BUDGET_SUB_TYPE_ID === "" || formDate.BUDGET_SUB_TYPE_ID === undefined) {
        $("#BUDGET_SUB_TYPE_ID").addClass("ng-touched ng-invalid validate-error");
        $("#BUDGET_SUB_TYPE_ID").removeClass("ng-untouched ng-valid");

        message += `Please select ${this.staticformFields?.BUDGET_SUB_TYPE_ID.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#BUDGET_SUB_TYPE_ID").addClass("ng-untouched ng-valid");
        $("#BUDGET_SUB_TYPE_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.TOTAL_FEE.RECORD_STATE == 1 && this.staticformFields?.TOTAL_FEE.IS_MANDATORY) {
      if (formDate.TOTAL_FEE === null || formDate.TOTAL_FEE === "" || formDate.TOTAL_FEE === undefined) {
        $("#TOTAL_FEE").addClass("ng-touched ng-invalid validate-error");
        $("#TOTAL_FEE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.TOTAL_FEE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        if (!isNaN(formDate.TOTAL_FEE)) {
          $("#TOTAL_FEE").addClass("ng-untouched ng-valid");
          $("#TOTAL_FEE").removeClass("ng-touched ng-invalid validate-error");
        }
        else {
          $("#TOTAL_FEE").addClass("ng-touched ng-invalid validate-error");
          $("#TOTAL_FEE").removeClass("ng-untouched ng-valid");
          message += `${this.staticformFields?.TOTAL_FEE.LABEL_NAME} will allow only numeric values<br/>`;
          isValid = false;
        }
      }
    }
    let totalfee = parseInt(formDate["TOTAL_FEE"]);
    let requested = parseInt(formDate["REQUESTED_AMOUNT"]);
    //const mailformat = /^w+([.-]?w+)*@w+([.-]?w+)*(.w{2,3})+$/;
    if (this.staticformFields?.REQUESTED_AMOUNT.RECORD_STATE == 1 && this.staticformFields?.REQUESTED_AMOUNT.IS_MANDATORY) {

      if (formDate.REQUESTED_AMOUNT === null || formDate.REQUESTED_AMOUNT === "" || formDate.REQUESTED_AMOUNT === undefined) {
        $("#REQUESTED_AMOUNT").addClass("ng-touched ng-invalid validate-error");
        $("#REQUESTED_AMOUNT").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.REQUESTED_AMOUNT.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        if (!isNaN(formDate.REQUESTED_AMOUNT)) {
          $("#REQUESTED_AMOUNT").addClass("ng-untouched ng-valid");
          $("#REQUESTED_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
        }
        else {
          $("#REQUESTED_AMOUNT").addClass("ng-touched ng-invalid validate-error");
          $("#REQUESTED_AMOUNT").removeClass("ng-untouched ng-valid");
          message += `${this.staticformFields?.REQUESTED_AMOUNT.LABEL_NAME} field will allow only numeric values<br/>`;
          isValid = false;
        }
      }
    }
    if (this.staticformFields?.REQUESTED_NOTES.RECORD_STATE == 1 && this.staticformFields?.REQUESTED_NOTES.IS_MANDATORY) {
      if (formDate.NOTES === null || formDate.NOTES === "" || formDate.NOTES === undefined) {
        $("#NOTES").addClass("ng-touched ng-invalid validate-error");
        $("#NOTES").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.REQUESTED_NOTES?.LABEL_NAME}<br/>`;
        isValid = false;
      } else if (formDate.NOTES != null && formDate.NOTES != undefined && formDate.NOTES.trim() == "") {
        $("#NOTES").addClass("ng-touched ng-invalid validate-error");
        $("#NOTES").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.REQUESTED_NOTES?.LABEL_NAME}<br/>`;
        isValid = false;
      }
      else {
        $("#NOTES").addClass("ng-untouched ng-valid");
        $("#NOTES").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (requested > totalfee) {
      $("#REQUESTED_AMOUNT").addClass("ng-touched ng-invalid validate-error");
      $("#REQUESTED_AMOUNT").removeClass("ng-untouched ng-valid");
      message += "Requested amount cannot be more than total fee<br/>";
      isValid = false;
    } else {
      $("#REQUESTED_AMOUNT").addClass("ng-untouched ng-valid");
      $("#REQUESTED_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
    }
    debugger;
    if (formDate["STATUS"] == 4) {
        if (this.staticformFields?.ALLOCATION_AMOUNT.RECORD_STATE == 1 && this.staticformFields?.ALLOCATION_AMOUNT.IS_MANDATORY) {
        if (formDate.ALLOCATION_AMOUNT === null || formDate.ALLOCATION_AMOUNT === "" || formDate.ALLOCATION_AMOUNT === undefined) {
          $("#ALLOCATION_AMOUNT").addClass("ng-touched ng-invalid validate-error");
          $("#ALLOCATION_AMOUNT").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.ALLOCATION_AMOUNT?.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          if (!isNaN(formDate.ALLOCATION_AMOUNT)) {
            $("#ALLOCATION_AMOUNT").addClass("ng-untouched ng-valid");
            $("#ALLOCATION_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
          }
          else {
            $("#ALLOCATION_AMOUNT").addClass("ng-touched ng-invalid validate-error");
            $("#ALLOCATION_AMOUNT").removeClass("ng-untouched ng-valid");
            message += "Allocation Amount field will allow only numeric values<br/>";
            isValid = false;
          }
        }
      }

      if (formDate["ALLOCATION_AMOUNT"] != null && parseInt(formDate["ALLOCATION_AMOUNT"]) > parseInt(formDate["REQUESTED_AMOUNT"])) {
        $("#ALLOCATION_AMOUNT").addClass("ng-touched ng-invalid validate-error");
        $("#ALLOCATION_AMOUNT").removeClass("ng-untouched ng-valid");
        message += "The allocation amount cannot be greater than requested amount<br/>";
        isValid = false;
      } else {
        $("#ALLOCATION_AMOUNT").addClass("ng-untouched ng-valid");
        $("#ALLOCATION_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
      }
      debugger;

      if (this.staticformFields?.ALLOCATION_DATE.RECORD_STATE == 1 && this.staticformFields?.ALLOCATION_DATE.IS_MANDATORY) {
        if (formDate.ALLOCATION_DATE === null || formDate.ALLOCATION_DATE === "" || formDate.ALLOCATION_DATE === undefined) {
          $("#ALLOCATION_DATE").addClass("ng-touched ng-invalid validate-error");
          $("#ALLOCATION_DATE").removeClass("ng-untouched ng-valid");
          message += `Please select ${this.staticformFields?.ALLOCATION_DATE?.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#ALLOCATION_DATE").addClass("ng-untouched ng-valid");
          $("#ALLOCATION_DATE").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (this.staticformFields?.ALLOCATION_NOTES.IS_Display && this.staticformFields?.ALLOCATION_NOTES.IS_MANDATORY) {
        if (formDate.ALLOCATION_NOTES === null || formDate.ALLOCATION_NOTES === "" || formDate.ALLOCATION_NOTES === undefined) {
          $("#ALLOCATION_NOTES").addClass("ng-touched ng-invalid validate-error");
          $("#ALLOCATION_NOTES").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.ALLOCATION_NOTES?.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#ALLOCATION_NOTES").addClass("ng-untouched ng-valid");
          $("#ALLOCATION_NOTES").removeClass("ng-touched ng-invalid validate-error");
        }
      }
    }
    if (formDate["STATUS"] > 10) {
      if (this.expStaticFields?.EXPENDITURE_AMOUNT.RECORD_STATE == 1 && this.expStaticFields?.EXPENDITURE_AMOUNT.IS_MANDATORY) {
        if (formDate.EXPENDITURE_AMOUNT === null || formDate.EXPENDITURE_AMOUNT === "" || formDate.EXPENDITURE_AMOUNT === undefined || parseInt(formDate["EXPENDITURE_AMOUNT"]) == 0) {
          $("#EXPENDITURE_AMOUNT").addClass("ng-touched ng-invalid validate-error");
          $("#EXPENDITURE_AMOUNT").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.expStaticFields?.EXPENDITURE_AMOUNT.LABEL_NAME} <br/>`;
          isValid = false;
          //return false;
        } else {
          $("#EXPENDITURE_AMOUNT").addClass("ng-untouched ng-valid");
          $("#EXPENDITURE_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (this.expStaticFields?.RECONCILIATION_UPLOAD.RECORD_STATE == 1 && this.expStaticFields?.RECONCILIATION_UPLOAD.IS_MANDATORY) {
        if (!this.uploadedFiles ||this.uploadedFiles.length == 0) {
          $("#RECONCILIATION_UPLOAD").addClass("ng-touched ng-invalid validate-error");
          $("#RECONCILIATION_UPLOAD").removeClass("ng-untouched ng-valid");
          message += `Please upload ${this.expStaticFields?.RECONCILIATION_UPLOAD.LABEL_NAME} <br/>`;
          isValid = false;
        } else {
          $("#RECONCILIATION_UPLOAD").addClass("ng-untouched ng-valid");
          $("#RECONCILIATION_UPLOAD").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (formDate["EXPENDITURE_AMOUNT"] != null && parseInt(formDate["EXPENDITURE_AMOUNT"]) > parseInt(formDate["ALLOCATION_AMOUNT"])) {
        $("#EXPENDITURE_AMOUNT").addClass("ng-touched ng-invalid validate-error");
        $("#EXPENDITURE_AMOUNT").removeClass("ng-untouched ng-valid");
        message += "The expenditure amount cannot be greater than the allocated amount<br/>";
        isValid = false;
      } else {
        $("#EXPENDITURE_AMOUNT").addClass("ng-untouched ng-valid");
        $("#EXPENDITURE_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
      }
    }
    //dyamic fields validations
    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      isValid = false;
      message = message + ExtenMsgs;
    }

    if (!isValid) {
      this.commonService.ValidationBanner(message)
    }
    return isValid;
  }

  onAllocateDate(event) {
    this.IsAllocatedDateModified = true;
    this.ALLOCATE_DATE = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.IsAllocatedDateModified,
    }
  }
  GetAllocateDate(): DateObject {
    const formModel = this.budgetForm.getRawValue();
    const CurrentDate = new Date();
    const date = new Date(formModel.ALLOCATION_DATE);
    if (this.ComparingDates(CurrentDate, date) || this.ALLOCATE_DATE == null || this.ALLOCATE_DATE == undefined) {
      this.ALLOCATE_DATE = {
        Day: date.getDate(),
        Month: (date.getMonth() + 1),
        Year: date.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false
      }
    }
    return this.ALLOCATE_DATE;
  }
  ComparingDates(oldDate: any, newDate: any) {
    if (oldDate != undefined && oldDate != null && oldDate != '') {
      let oDt = oldDate.getDate().toString() + oldDate.getMonth().toString() + oldDate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt)
        return true;
      else
        return false;
    }
    else
      return false;
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  OpenFile(item: Document_Upload_File): void {
    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }
  isAllowedExtensionFile(Filename) {
    return this.commonService.isAllowedExtension(Filename);
  }
  saveTempFiles(selectedFiles: any) {
    const formData = new FormData();
    formData.append(`files`, selectedFiles);
    return this.fileService.uploadMultiFiles(formData, "");
  }
  uploadchange(event): void {
    //let Flag = true;
    if (this.uploadedFiles == undefined || this.uploadedFiles == null) {
      this.uploadedFiles = [];
    }
    let Isexe = false;
    let Is5oMB = false;
    let IscrdDownload = false;
    // let hasUnFormat = false;
    let hasMultipleFiles = false;
    let Duplicate_File_List = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      let file = event.target.files[i].name;
      let ext = file.match(/\.([^\.]+)$/)[1];
      let filesize = event.target.files[i].size;

      if (file != null && (ext == 'exe')) {
        Isexe = true;
      }
      else if (file != null && (ext == 'crdownload')) {
        IscrdDownload = true;
      }
      else {
        this.saveTempFiles(event.target.files[i]).subscribe((result: any) => {
          let uploadFile = new Document_Upload_File();
          uploadFile.ID = result.Data[0].FileID;
          
          uploadFile.DOCUMENT_NAME = event.target.files[i].name;
          uploadFile.File = null;
          uploadFile.Status = "Add";
          uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
          let hasValue = this.uploadedFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
          if (hasValue.length > 0) {
            this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
          }
          else if (this.expStaticFields?.RECONCILIATION_UPLOAD?.IS_MULTISELECT) {
            this.uploadedFiles.push(uploadFile);
          } else {
            this.uploadedFiles.forEach((item) => {
              item.Status = "Delete";
            })
            this.uploadedFiles.push(uploadFile);
          }
        });

      }
    }
    if (Is5oMB && Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 500MB");
    }

    else if (Is5oMB) {
      this.commonService.ValidationBanner("Accepts maximum file size 50MB");
    }

    else if (Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
    }
    else if (IscrdDownload) {
      this.commonService.ValidationBanner("The system does not support .crdownload files. Please choose a different file format to save the details.")
    }
    else {

    }
  }


  resetInput(event: Event) {
    (event.target as HTMLInputElement).value = '';
  }

  DeleteUpload(file): void {

    let code = file.ID;
    if (file.Status == "Add") {
      this.uploadedFiles = this.uploadedFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x) => {
        if (x["Status"] == 2 && x["Data"] == false) {
          this.commonService.ValidationBanner(x["Message"]);
        }
        else {
          file.Status = "Delete";
          let index = this.uploadedFiles.findIndex(x => x.ID == file.ID);
        }
      });
    }
  }
}
